module.exports = __webpack_public_path__ + "img/image14.bce3d3a0.jpg";